// Validar formato de RUT chileno (acepta de 7 a 9 dígitos)
export const validarFormatoRUT = (rut) => {
  // Permite formatos como:
  // 1.234.567-8
  // 12.345.678-9
  // 123.456.789-0
  const regex = /^(\d{1,3}\.)?(\d{3}\.)?(\d{3})-(\d|k|K)$/;
  return regex.test(rut);
};

// Formatear RUT (agregar puntos y guión)
export const formatearRUT = (rut) => {
  // Remover todo excepto números y K
  let rutLimpio = rut.replace(/[^\dkK]/g, '');
  
  // Validar longitud mínima
  if (rutLimpio.length < 2) {
    return rut;
  }
  
  // Separar número y dígito verificador
  const dv = rutLimpio.slice(-1).toUpperCase();
  const numero = rutLimpio.slice(0, -1);
  
  // Agregar puntos de derecha a izquierda
  let numeroFormateado = '';
  let contador = 0;
  
  for (let i = numero.length - 1; i >= 0; i--) {
    numeroFormateado = numero[i] + numeroFormateado;
    contador++;
    if (contador === 3 && i > 0) {
      numeroFormateado = '.' + numeroFormateado;
      contador = 0;
    }
  }
  
  return `${numeroFormateado}-${dv}`;
};

// Calcular dígito verificador
export const calcularDV = (rut) => {
  // Limpiar el RUT (solo números)
  const rutLimpio = rut.replace(/[^\d]/g, '');
  
  let suma = 0;
  let multiplo = 2;
  
  // Recorrer de derecha a izquierda
  for (let i = rutLimpio.length - 1; i >= 0; i--) {
    suma += parseInt(rutLimpio[i]) * multiplo;
    multiplo = multiplo === 7 ? 2 : multiplo + 1;
  }
  
  const resto = suma % 11;
  const dv = 11 - resto;
  
  if (dv === 11) return '0';
  if (dv === 10) return 'K';
  return dv.toString();
};

// Validar RUT completo (formato y dígito verificador)
export const validarRUT = (rut) => {
  // Si está vacío, es válido (es opcional)
  if (!rut || rut.trim() === '') {
    return { valido: true, mensaje: 'RUT válido' };
  }

  // Limpiar el RUT
  const rutLimpio = rut.replace(/[^\dkK]/g, '');
  
  // Validar longitud mínima
  if (rutLimpio.length < 2) {
    return { valido: false, mensaje: 'RUT muy corto' };
  }

  // Validar longitud máxima (9 dígitos + 1 DV = 10)
  if (rutLimpio.length > 10) {
    return { valido: false, mensaje: 'RUT muy largo' };
  }
  
  // Extraer número y dígito verificador
  const numero = rutLimpio.slice(0, -1);
  const dvIngresado = rutLimpio.slice(-1).toUpperCase();
  
  // Validar que el número solo contenga dígitos
  if (!/^\d+$/.test(numero)) {
    return { valido: false, mensaje: 'RUT contiene caracteres inválidos' };
  }
  
  // Calcular dígito verificador correcto
  const dvCalculado = calcularDV(numero);
  
  // Comparar
  if (dvIngresado !== dvCalculado) {
    return { 
      valido: false, 
      mensaje: `Dígito verificador incorrecto. Debería ser ${dvCalculado}` 
    };
  }
  
  return { valido: true, mensaje: 'RUT válido' };
};

// Limpiar RUT (quitar puntos y guión)
export const limpiarRUT = (rut) => {
  return rut.replace(/[^\dkK]/g, '');
};

// Función auxiliar para auto-formatear mientras el usuario escribe
export const formatearRUTMientrasEscribe = (value) => {
  // Eliminar todo excepto números y K
  let limpio = value.replace(/[^\dkK]/g, '').toUpperCase();
  
  // Limitar a 9 dígitos + 1 DV
  if (limpio.length > 10) {
    limpio = limpio.slice(0, 10);
  }
  
  // Si tiene más de 1 carácter, formatear
  if (limpio.length > 1) {
    const dv = limpio.slice(-1);
    const numero = limpio.slice(0, -1);
    
    // Agregar puntos
    let numeroFormateado = '';
    let contador = 0;
    
    for (let i = numero.length - 1; i >= 0; i--) {
      numeroFormateado = numero[i] + numeroFormateado;
      contador++;
      if (contador === 3 && i > 0) {
        numeroFormateado = '.' + numeroFormateado;
        contador = 0;
      }
    }
    
    return `${numeroFormateado}-${dv}`;
  }
  
  return limpio;
};